import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  processWithdrawlRequest,
  completeWithdrawlRequest,
  getWithdrawlDetail
} from '../../api/sportaloka-client';
import {
  getWithdrawlHistoryContent,
  getWithdrawStatusColor,
  getWithdrawStatusLabel
} from '../../helpers/status';
import { format } from 'date-fns';
import WithdrawlHistory from './components/WithdrawlHistory';
import RejectWithdrawlModal from './components/RejectWithdrawlModal';
import Swal from 'sweetalert2';

const WithdrawlDetail = () => {
  const { id } = useParams();
  const [initLoading, setInitLoading] = useState();
  const [initError, setInitError] = useState();
  const [data, setData] = useState(null);
  const [histories, setHistories] = useState([]);

  const getData = async () => {
    try {
      setInitError(false);
      setInitLoading(true);
      const response = await getWithdrawlDetail(id);
      const responseData = response.data.data;
      const bookingHistories = responseData.withdrawl_histories.map((item) =>
        getWithdrawlHistoryContent(item)
      );
      setData(responseData);
      setHistories(bookingHistories);
      setInitLoading(false);
    } catch (error) {
      setInitError(true);
      setInitLoading(false);
    }
  };

  const handleProcess = () => {
    Swal.fire({
      title: 'Apakah anda yakin ingin memproses permintaan ini?',
      text: 'Pastikan anda sudah yakin dengan aksi ini.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, saya yakin!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setInitLoading(true);
          await processWithdrawlRequest(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: 'Data berhasil di proses.',
            icon: 'success'
          });
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setInitLoading(false);
        }
      }
    });
  };

  const handleComplete = () => {
    Swal.fire({
      title: 'Apakah anda yakin menyelesaikan permintaan ini?',
      text: 'Pastikan dana telah di transfer ke rekening yang diajukan.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, saya yakin!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setInitLoading(true);
          await completeWithdrawlRequest(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: 'Data berhasil di selesaikan.',
            icon: 'success'
          });
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setInitLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Detail Penarikan Saldo</h1>
          <div className="d-flex">
            <Link to="/withdrawl" className="button -sm px-3 bg-white h-50 text-dark">
              <i className="fa fa-arrow-left mr-10" />
              Kembali
            </Link>
            {data && data.status === 'NEW' && (
              <div>
                <button
                  disabled={initLoading}
                  onClick={handleProcess}
                  className="button -sm px-3 bg-blue-1 h-50 text-white ml-20">
                  <i className="fa fa-check mr-10" />
                  Proses Penarikan
                </button>
              </div>
            )}

            {data && (data.status === 'PROCESS' || data.status === 'NEW') && (
              <div>
                <button
                  disabled={initLoading}
                  className="button -sm px-3 bg-danger h-50 text-white ml-20"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal">
                  <i className="fa fa-close mr-10" />
                  Tolak Penarikan
                </button>
                <RejectWithdrawlModal onFetchData={getData} />
              </div>
            )}

            {data && data.status === 'PROCESS' && (
              <button
                onClick={handleComplete}
                disabled={initLoading}
                className="button -sm px-3 bg-blue-1 h-50 text-white ml-20">
                <i className="fa fa-check mr-10" />
                Selesaikan
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <WithdrawlHistory
              data={histories}
              initLoading={initLoading}
              initError={initError}
              retry={getData}
            />
          </div>
          <div className="col-9">
            <div
              className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20"
              style={{ minHeight: 540 }}>
              {initLoading && !initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100"
                  style={{ minHeight: 540 }}>
                  <div className="loader" />
                  <div className="fw-600" style={{ marginLeft: 12 }}>
                    Loading...
                  </div>
                </div>
              )}
              {!initLoading && initError && (
                <div
                  className="d-flex align-items-center justify-content-center h-100 text-center"
                  style={{ minHeight: 540 }}>
                  <p className="fw-600">
                    Gagal! Periksa koneksi internet anda dan{' '}
                    <span className="text-danger cursor-pointer" onClick={getData}>
                      Coba lagi
                    </span>
                  </p>
                </div>
              )}
              {!initLoading && !initError && (
                <div>
                  <div>
                    <h5 className="fw-700 text-blue-1 text-18">Informasi Penarikan</h5>
                    <table className="table table-striped mt-20">
                      <tbody>
                        <tr>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="30%">
                            Tanggal Penarikan
                          </td>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="5%">
                            :
                          </td>
                          <th
                            style={{ verticalAlign: 'middle' }}
                            className="text-right px-3 py-2 text-14">
                            {data && format(new Date(data.created_at), 'dd/MM/yyyy HH:MM:ss')}
                          </th>
                        </tr>
                        <tr>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="30%">
                            Update Terakhir
                          </td>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="5%">
                            :
                          </td>
                          <th
                            style={{ verticalAlign: 'middle' }}
                            className="text-right px-3 py-2 text-14">
                            {data && format(new Date(data.updated_at), 'dd/MM/yyyy HH:MM:ss')}
                          </th>
                        </tr>
                        <tr>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="30%">
                            Jumlah Penarikan
                          </td>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="5%">
                            :
                          </td>
                          <th
                            style={{ verticalAlign: 'middle' }}
                            className="text-right px-3 py-2 text-14">
                            IDR {data && data.amount.toLocaleString('id-ID')}
                          </th>
                        </tr>
                        <tr>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="30%">
                            Fee Penarikan
                          </td>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="5%">
                            :
                          </td>
                          <th
                            style={{ verticalAlign: 'middle' }}
                            className="text-right px-3 py-2 text-14">
                            IDR {data && data.fee_amount.toLocaleString('id-ID')}
                          </th>
                        </tr>
                        <tr>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="30%">
                            Jumlah yang harus di transfer
                          </td>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="5%">
                            :
                          </td>
                          <th
                            style={{ verticalAlign: 'middle' }}
                            className="text-right px-3 py-2 text-14">
                            IDR {data && (data.amount - data.fee_amount).toLocaleString('id-ID')}
                          </th>
                        </tr>
                        <tr>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="30%">
                            Rekening Bank
                          </td>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="5%">
                            :
                          </td>
                          <th
                            style={{ verticalAlign: 'middle' }}
                            className="text-right px-3 py-2 text-14">
                            {data && data.bank
                              ? `${data.bank.bank_name} ${data.bank.account_number} a/n ${data.bank.account_name}`
                              : '-'}
                          </th>
                        </tr>
                        <tr>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="30%">
                            Status
                          </td>
                          <td
                            className="px-3 py-2"
                            style={{ verticalAlign: 'middle !important' }}
                            width="5%">
                            :
                          </td>
                          <th
                            style={{ verticalAlign: 'middle' }}
                            className="text-right px-3 py-2 text-14">
                            <span
                              className={`px-2 py-1 rounded-1 fw-600 ${data && getWithdrawStatusColor(data.status)}`}>
                              {data && getWithdrawStatusLabel(data.status)}
                            </span>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawlDetail;
